



























































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Modal } from 'ant-design-vue'
import RiskSection from '@/views/AiiTasks/riskSection.vue'
import TaskApi from '@/api/task'
import InvestigateApi from '@/api/investigate'
import { download, triggerWindowResizeEvent } from '@/utils/util'
import {
	DAI_JIE_DAN,
	DAI_ZUO_YE,
	ZUO_YE_ZHONG,
	QU_XIAO_ZHONG,
	QU_XIAO_ZHONG_CHU_SHEN,
	DAI_ZHONG_SHEN,
	YI_WAN_CHENG,
} from '@/web-task/config'
import { RESURVEY } from '@/utils/const'
import moment from 'moment'
import EvaluateApi from '@/api/evaluate'
import MediateApi from '@/api/mediate'
import bus from '@/views/AiiTasks/bus'
import MsgBoardDialog from './MsgBoardDialog.vue'
const OTHER_VALUE = '07'

@Component({
	components: {
		RiskSection,
		MsgBoardDialog,
	},
})
export default class DetailHeaderBtns extends Vue {
	private returnVisible: boolean = false
	private returnLoading: boolean = false
	private reassignVisible = false
	private reassignLoading = false
	private exportVisible = false
	private reassignCompany = ''
	private auditCancelVisible: boolean = false
	private auditCancelLoading: boolean = false
	private postponeVisible: boolean = false
	private postponeLoading: boolean = false
	private postponeHours: any = 12
	private revokeDialogVisible: boolean = false
	private cancelLoading: boolean = false
	private evaluateLoading: boolean = false
	private downloading: boolean = false
	private exporting: boolean = false
	private taskLog: any = []
	private taskLogVisible: boolean = false
	private resurveyCountdown: any = 0
	private canResurvey: boolean = false
	private canCreateSecondary = false
	public evaluateVisible: boolean = false
	public evaluateInfo: any = ''
	public evaluateForm: any = ''
	public rate: number = 5
	public labelMap: any = {}
	public labelList: any = []

	private cancelForm: any = {}
	private auditCancelForm: any = {}
	private returnForm: any = {}
	private exportForm: any = {}

	private visitorPopupShow: boolean = true
	private mediateConfirm: any = ''
	private showMsgBoard: boolean = false

	private showRiskModal = false
	private DAI_JIE_DAN: any = DAI_JIE_DAN
	private OTHER_VALUE = OTHER_VALUE

	private visiblePass: boolean = false
	private passForm: any = {}

	@Prop()
	private order!: any

	@Prop()
	private task!: any

	@Prop()
	private injured!: any

	@Prop()
	private riskList!: any

	@Prop()
	private beforeClick: any

	@Prop()
	private audit!: any

	private get cancelOptions() {
		const cancelTypeList = this.$store.state.setting.cancelReasonTypeList
		return cancelTypeList.map((item: any) => ({
			label: item.value,
			value: item.key,
		}))
	}

	@Watch('order', { immediate: true })
	private onOrderChange() {
		if (this.order) {
			this.getOrderExStatusInfo()
			this.evaluateInfo = ''
			this.getEvaluate()
			if (
				this.task.isMediate &&
				this.order.orderStatus === '04' &&
				this.order.auditOperationTime
			) {
				// 是否需要调解弹窗
				// if (this.mediateConfirm && this.mediateConfirm.destory) {
				// 	this.mediateConfirm.destory()
				// }
				;(Modal as any).destroyAll()
				if (this.order.creator === this.$store.state.user.userInfo.userId) {
					this.isNeedMediate()
				}
			}
		}
	}

	public getEvaluate(): any {
		if (!this.$route.params.orderId) {
			return
		}
		return EvaluateApi.getEvaluate({
			businessId: this.$route.params.orderId,
			evType: 'insurance',
		}).then((res: any) => {
			this.labelList = []
			this.labelMap = {}
			this.rate = 5
			this.evaluateForm.resetFields()
			if (res.data[0]) {
				this.evaluateInfo = res.data[0]
				this.labelList = res.data[0].labels
			}
		})
	}

	public evaluateOrder() {
		const id = this.evaluateInfo.id
		this.evaluateLoading = true
		EvaluateApi.saveEvaluate({
			id,
			userId: this.$store.state.user.userInfo.userId,
			urerName: this.$store.state.user.userInfo.userName,
			score: this.rate,
			comment: this.evaluateForm.getFieldValue('comment'),
			labels: this.labelList
				.map((item: any) => item.id)
				.filter((item: any) => this.labelMap[item]),
		})
			.then((res: any) => {
				this.$message.success('评价完成')
				this.evaluateVisible = false
				this.needRiskModal()
				this.getEvaluate()
			})
			.finally(() => {
				this.evaluateLoading = false
			})
	}

	private handleCancel() {
		this.visiblePass = false
		this.$emit('getDetail')
	}
	private handleOk() {
		const order = this.order
		if (this.task.isMediate) {
			// 作业审核
			return MediateApi.auditConciliationTask({
				orderId: this.$route.params.orderId,
				pass: '1',
				insufficiency: this.passForm.insufficiency,
				insufficiencyRemark: this.passForm.insufficiencyRemark,
			}).then((res: any) => {
				this.visiblePass = false
				// passConfirm.destroy()
				this.$emit('getDetail')
				// this.isNeedMediate()
			})
		}
		return TaskApi.auditTask({
			id: order.operationId,
			orderId: this.$route.params.orderId,
			status: '04',
			orderStatus: '05',
		}).then((res: any) => {
			this.$emit('getDetail')
			this.getEvaluate().then(() => {
				if (this.evaluateInfo.evStatus === '0') {
					this.evaluateVisible = true
				}
			})
		})
	}

	private chcekInsufficiency() {
		this.$confirm({
			title: '提示',
			content: '确认资料已补充 ?',
			onOk: () => {
				return TaskApi.sufficiency({
					orderId: this.$route.params.orderId,
				}).then((res: any) => {
					this.getDetail()
					this.$message.success('资料已补充成功')
				})
			},
		})
	}

	private getDetail() {
		this.$emit('getDetail')
	}

	private auditTaskPass() {
		if (this.beforeClick) {
			const flag = this.beforeClick()
			if (!flag) {
				return
			}
		}
		// if (this.order.insufficiency != '1') {
		// 	this.visiblePass = true
		// } else {
		const order = this.order
		let passConfirm = this.$confirm({
			title: '提示',
			content: '确认审核通过吗 ?',
			onOk: () => {
				if (this.task.isMediate) {
					// 作业审核
					return MediateApi.auditConciliationTask({
						orderId: this.$route.params.orderId,
						pass: '1',
					}).then((res: any) => {
						passConfirm.destroy()
						this.$emit('getDetail')
						// this.isNeedMediate()
					})
				}
				return TaskApi.auditTask({
					id: order.operationId,
					orderId: this.$route.params.orderId,
					status: '04',
					orderStatus: '05',
				}).then((res: any) => {
					this.$emit('getDetail')
					this.getEvaluate().then(() => {
						if (this.evaluateInfo.evStatus === '0') {
							this.evaluateVisible = true
						}
					})
				})
			},
		})
		// }
	}

	private isNeedMediate() {
		this.mediateConfirm = this.$confirm({
			title: '提示',
			content:
				'是否需要作业人员在线下进行调解，如果不需要则任务即可完成，如果需要请设置对应的调解金额。',
			onOk: () => {
				this.$emit('addMediateTab')
			},
			onCancel: () => {
				MediateApi.createConciliation(this.$route.params.orderId, '0', {}).then(
					(res: any) => {
						this.$emit('getDetail')
						this.getEvaluate().then(() => {
							if (this.evaluateInfo.evStatus === '0') {
								this.evaluateVisible = true
							}
						})
					}
				)
			},
			okText: '需要调解',
			cancelText: '不需要调解',
		})
	}

	public choose(i: any) {
		this.rate = i
	}

	public get canEvaluate() {
		const evStatus = this.evaluateInfo.evStatus
		const accessUserId = this.evaluateInfo.accessUserId
		if (evStatus && evStatus === '0') {
			if (accessUserId === this.$store.state.user.userInfo.userId) {
				return true
			}
			// 自动审核通过 有审核权限即可评价
			if (accessUserId === '-1') {
				if (
					this.order.creator === this.$store.state.user.userInfo.userId ||
					this.$auth('taskDetail:auditTask') ||
					this.$auth('wpDetail:auditTask')
				) {
					return true
				}
			}
		}
		return false
	}

	public get canReassign() {
		return [
			DAI_JIE_DAN,
			DAI_ZUO_YE,
			ZUO_YE_ZHONG,
			QU_XIAO_ZHONG,
			QU_XIAO_ZHONG_CHU_SHEN,
		].includes(this.order.orderStatus)
	}

	public get canRejudge() {
		return [DAI_ZHONG_SHEN, YI_WAN_CHENG].includes(this.order.orderStatus)
	}

	private closeEvaluate() {
		this.evaluateVisible = false
		this.needRiskModal()
	}

	private needRiskModal() {
		if (
			this.riskList &&
			this.riskList.length &&
			this.$auth('taskDetail:riskList')
		) {
			this.showRiskModal = true
		}
	}

	// 获取是否展示复勘按钮
	private async getOrderExStatusInfo() {
		if (!this.$route.params.orderId) {
			return
		}
		const res = await TaskApi.getOrderExStatusInfo(this.$route.params.orderId)
		const data = res.data
		this.canResurvey = data.canCreateNewOrder
		this.canCreateSecondary = data.canCreateSecondary
		this.$emit('getEx', data)
		this.$nextTick(() => {
			triggerWindowResizeEvent()
		})
		if (data.lastSubmitTime) {
			const today = new Date(this.order.serverTime)
			const last = new Date(data.lastSubmitTime)

			const countdown = moment([
				today.getFullYear(),
				today.getMonth(),
				today.getDate(),
			]).diff(
				moment([last.getFullYear(), last.getMonth(), last.getDate()]),
				'days'
			)

			this.resurveyCountdown = countdown + 1
		} else {
			this.resurveyCountdown = false
		}
	}

	private auditTaskReturn() {
		if (this.beforeClick) {
			const flag = this.beforeClick()
			if (!flag) {
				return
			}
		}
		this.returnForm.resetFields()
		this.returnVisible = true
	}

	private auditReturnSec() {
		this.returnVisible = false
		this.$emit('getDetail')
		this.$message.success('审核退回成功')
	}

	// 审核退回
	private returnOk() {
		this.returnForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.returnLoading = true
				if (this.order.orderStatus === '16' && this.task.isMediate) {
					// 调解-待确认-退回
					MediateApi.auditConciliationAgreement({
						orderId: this.$route.params.orderId,
						pass: '0',
						comment: values.comment,
					})
						.then((res: any) => {
							this.auditReturnSec()
						})
						.finally(() => {
							this.returnLoading = false
						})
				} else if (this.order.orderStatus === '04' && this.task.isMediate) {
					// 调解-待终审-退回
					MediateApi.auditConciliationTask({
						orderId: this.$route.params.orderId,
						pass: '0',
						comment: values.comment,
					})
						.then((res: any) => {
							this.auditReturnSec()
						})
						.finally(() => {
							this.returnLoading = false
						})
				} else if (this.order.orderStatus === '04') {
					// 终审退回
					TaskApi.auditTask({
						id: this.order.operationId,
						orderId: this.$route.params.orderId,
						status: '01',
						orderStatus: '02',
						comment: values.comment,
					})
						.then((res: any) => {
							this.auditReturnSec()
						})
						.finally(() => {
							this.returnLoading = false
						})
				} else if (this.order.orderStatus === '031') {
					// 初审退回
					TaskApi.checkTask({
						orderId: this.$route.params.orderId,
						pass: '0',
						comment: values.comment,
					})
						.then((res: any) => {
							this.auditReturnSec()
						})
						.finally(() => {
							this.returnLoading = false
						})
				}
			}
		})
	}

	private auditCancelReject() {
		this.auditCancelVisible = true
		this.auditCancelForm.resetFields()
	}

	// 拒绝撤单申请
	private deAuditCancel() {
		this.auditCancelForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.auditCancelLoading = true
				const copy = {
					...values,
					orderId: this.$route.params.orderId,
					pass: 0,
				}
				TaskApi.auditCancelTask(copy)
					.then((res: any) => {
						this.$message.success('撤单申请已拒绝')
						this.auditCancelVisible = false
						this.$emit('getDetail')
					})
					.finally(() => {
						this.auditCancelLoading = false
					})
			}
		})
	}

	// 同意撤单
	public auditCancelPass() {
		let operatorArrived = false
		if (this.order.applyCancels && this.order.applyCancels.length) {
			const apply = this.order.applyCancels.find(
				(item: any) => item.dataType === 'application'
			)

			operatorArrived = apply.type === '2'
		}
		const obj: any = {
			title: '提示',
			content: `确认同意撤单吗 ?`,
			onOk: () => {
				return TaskApi.auditCancelTask({
					orderId: this.$route.params.orderId,
					pass: 1,
				}).then((res: any) => {
					this.$message.success('撤单申请已同意')
					this.$emit('getDetail')
				})
			},
		}

		if (operatorArrived) {
			obj.content = (h: any) => {
				return h('div', {}, [
					h('div', '确认同意撤单吗 ?'),
					h(
						'div',
						{
							style: {
								color: '#E02020',
								marginTop: '6px',
							},
						},
						`注：因作业人员已到达作业地点，请认真审核撤单提交的资料是否属实，如撤单成功该任务会产生相应的费用！`
					),
				])
			}
		}

		this.$confirm(obj)
	}

	private resurvey() {
		this.$multiTab.close('/AiiTasks/addResurvey?resurvey=1')
		this.$ss.set(
			'resurveyOrder',
			{
				orderId: this.$route.params.orderId,
				insuranceType: this.order.insuranceType,
			},
			10 * 60 * 1000
		)
		this.$nextTick(() => {
			this.$router.push('/AiiTasks/addResurvey?resurvey=1')
		})
	}

	private resurveyAgain() {
		this.$multiTab.close('/AiiTasks/addResurvey?resurvey=1')
		this.$ss.set(
			'resurveyOrder',
			{
				orderId: this.$route.params.orderId,
				insuranceType: this.order.insuranceType,
				isWholeProcess: this.task.isWholeProcess,
				isSecondary: true,
				wholeProcessType: RESURVEY,
			},
			10 * 60 * 1000
		)
		this.$nextTick(() => {
			this.$router.push('/AiiTasks/addResurvey?resurvey=1')
		})
	}

	private postponeOrder() {
		this.postponeHours = 12
		this.postponeVisible = true
	}

	private postponeOk() {
		if (!this.postponeHours) {
			return this.$message.error('请选择订单延长时长')
		}
		this.postponeLoading = true
		return TaskApi.postponeOrder({
			orderId: this.$route.params.orderId,
			hours: this.postponeHours,
		})
			.then(() => {
				this.postponeVisible = false
				this.$message.success('延期成功')
				this.$emit('getDetail')
			})
			.finally(() => {
				this.postponeLoading = false
			})
	}

	private cancelOrder() {
		this.revokeDialogVisible = true
		this.cancelForm.resetFields()
	}

	private cancelOk() {
		this.cancelForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.cancelLoading = true
				const copy = {
					...values,
					orderId: this.$route.params.orderId,
				}
				TaskApi.cancelOrder(copy)
					.then((res: any) => {
						this.$message.success('撤销成功')
						this.revokeDialogVisible = false
						this.$emit('getDetail')
					})
					.finally(() => {
						this.cancelLoading = false
					})
			}
		})
	}

	private showReassign() {
		this.reassignVisible = true
	}

	private showRejudge() {
		this.$confirm({
			title: '回传保司提醒',
			content:
				'信息回传保司失败后重试使用，若未失败请勿操作回传保司，请确定是否需将信息重新回传保司？',
			onOk: () => {
				return TaskApi.post2Insurance({
					orderId: this.$route.params.orderId,
				}).then((res: any) => {
					console.log(res)
					if (res.code === 200) {
						this.$message.success('回传保司成功')
					} else {
						this.$message.error('回传保司失败，请稍候重试')
					}
				})
			},
		})
	}

	private showExport() {
		this.exportVisible = true
	}

	private onSelectPartner(selectedKeys: any) {
		this.reassignCompany = selectedKeys[0]
	}

	private reassign() {
		if (!this.reassignCompany) {
			this.$message.error('请选择资源公司')
			return
		}
		this.reassignLoading = true
		TaskApi.changePartner({
			orderId: this.$route.params.orderId,
			companyId: this.reassignCompany + '',
		})
			.then((res: any) => {
				this.reassignVisible = false
				this.$emit('getDetail')
			})
			.finally(() => {
				this.reassignLoading = false
			})
	}

	private downloadFile(key: string, sucCb: Function, errCb: Function) {
		return TaskApi.checkExportFinish({ key })
			.then((res: any) => {
				const isDone = res.data && res.data.done
				if (isDone) {
					TaskApi.downloadWithKey({ key })
						.then((res: any) => {
							const blob: any = new Blob([res.data])
							download(blob, res.filename)
							sucCb.call(this)
						})
						.catch(() => {
							errCb.call(this)
						})
				} else {
					setTimeout(() => {
						this.downloadFile(key, sucCb, errCb)
					}, 1500)
				}
			})
			.catch(() => {
				errCb.call(this)
			})
	}

	private exportOrder() {
		this.exportForm.validateFields((error: any, values: any) => {
			if (!error) {
				this.exporting = true

				const requestData = {
					orderId: this.$route.params.orderId,
					compress: values.compress === '1',
				}
				let exportPromise: Promise<any> = Promise.resolve()
				if (this.task.isMediate) {
					exportPromise = MediateApi.exportOrder(requestData)
				} else if (this.task.isOtherInvestigate) {
					exportPromise = TaskApi.exportOtherSurvey(requestData)
				} else if (this.task.isInvestigate) {
					exportPromise = InvestigateApi.exportOrder(requestData)
				} else {
					exportPromise = TaskApi.exportOrder(requestData)
				}
				exportPromise
					.then((res: any) => {
						const key = res.data
						this.downloadFile(
							key,
							() => {
								this.$message.success('导出完成')
								this.exportVisible = false
								this.exporting = false
								this.exportForm.resetFields()
							},
							() => {
								this.exporting = false
							}
						)
					})
					.catch(() => {
						this.exporting = false
					})
			}
		})
	}

	private getTaskLog() {
		TaskApi.getTaskLog(this.$route.params.orderId).then((res: any) => {
			this.taskLog = res.data
			this.taskLogVisible = true
		})
	}

	private toggleVisitorShow() {
		this.visitorPopupShow = !this.visitorPopupShow
	}

	private beforeDestroy() {
		bus.$off('showEvaluate')
	}

	private activated() {
		bus.$on('showEvaluate', () => {
			this.getEvaluate().then(() => {
				if (this.evaluateInfo.evStatus === '0') {
					this.evaluateVisible = true
				}
			})
		})
	}

	private deactivated() {
		bus.$off('showEvaluate')
	}

	private created() {
		this.cancelForm = this.$form.createForm(this)
		this.auditCancelForm = this.$form.createForm(this)
		this.returnForm = this.$form.createForm(this)
		this.evaluateForm = this.$form.createForm(this)
		this.exportForm = this.$form.createForm(this)

		this.$store.dispatch('setting/initPartnerTree')
	}
}
